import React, { useState } from 'react';
import { MarkerF, InfoWindowF } from '@react-google-maps/api';
import MapMarker from 'assets/images/maps-marker.svg';
import SelectedMapMarker from 'assets/images/maps-marker-center.svg';

const MARKER_WIDTH = 38;
const MARKER_HEIGHT = 46;

const getMarkerIcon = (isSelected) => {
  if (isSelected) {
    return {
      url: SelectedMapMarker,
      scaledSize: new window.google.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
      anchor: new window.google.maps.Point(MARKER_WIDTH / 2, MARKER_HEIGHT)
    };
  }
  return {
    url: MapMarker,
    scaledSize: new window.google.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
    anchor: new window.google.maps.Point(MARKER_WIDTH / 2, MARKER_HEIGHT)
  };
};

const CustomPartnerMarker = ({ location, isSelected, onMarkerClick, onMarkerMouseOver, onMarkerMouseOut }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (onMarkerClick) {
      onMarkerClick(location);
    }
  };

  const handleMouseOver = () => {
    setIsHovered(true);
    if (onMarkerMouseOver) {
      onMarkerMouseOver(location);
    }
  };

  const handleMouseOut = () => {
    setIsHovered(false);
    if (onMarkerMouseOut) {
      onMarkerMouseOut(location);
    }
  };

  return (
    <>
      <MarkerF
        position={{ lat: location.lat, lng: location.lng }}
        icon={getMarkerIcon(isSelected)}
        onClick={handleClick}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        clickable={true}
      />
      {(isHovered || isSelected) && (
        <InfoWindowF
          position={{ lat: location.lat, lng: location.lng }}
          options={{
            zIndex: 5,
            pixelOffset: new window.google.maps.Size(0, -47),
            headerDisabled: true
          }}
        >
          <div style={{ color: '#000000', fontSize: '14px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
            {location.name}
          </div>
        </InfoWindowF>
      )}
    </>
  );
};

export default CustomPartnerMarker;
